import { isValidNumber } from "utils/ts-utils";
import { array, lazy, number, object } from "yup";
import type { FormStorageLocProductSale } from "../../purchase-request-types";
import type { SetupPurchaserRequestFormValues } from "../organisation-purchase-request-setup-page";

export const productSchema = lazy(
  (selectedProduct: FormStorageLocProductSale) => {
    let quantitySchema = number().positive().required("Quantity is required");
    if (selectedProduct.totalAvailable && !selectedProduct.totalProducible) {
      quantitySchema = quantitySchema.max(
        selectedProduct.totalAvailable,
        `Exceeds max available: (${selectedProduct.totalAvailable})`,
      );
    } else if (
      !selectedProduct.totalAvailable &&
      selectedProduct.totalProducible
    ) {
      quantitySchema = quantitySchema.max(
        selectedProduct.totalProducible,
        `Exceeds max producible: (${selectedProduct.totalProducible})`,
      );
    } else {
      const maxAllowed =
        selectedProduct.totalAvailable + selectedProduct.totalProducible;
      quantitySchema = quantitySchema.max(
        maxAllowed,
        `Exceeds max available + producible: (${maxAllowed})`,
      );
    }

    const hasFreeUnits =
      selectedProduct.freeUnits && Number(selectedProduct.freeUnits) > 0;
    if (hasFreeUnits) {
      return object()
        .shape(
          {
            unitPrice: number().min(0).optional(),
            priceDiscount: number().positive().optional(),
            paidUnits: number().positive().optional(),
            freeUnits: quantitySchema,
          },
          [["price", "quantity"]],
        )
        .required();
    }

    return object()
      .shape(
        {
          unitPrice: number().min(0).required("Price is required"),
          priceDiscount: number().positive().optional(),
          paidUnits: quantitySchema,
          freeUnits: number().positive().optional(),
        },
        [["price", "quantity"]],
      )
      .required();
  },
);

export const validationSchema = object()
  .shape({
    products: array()
      // Note: (typescript bug): https://github.com/jquense/yup/issues/1283
      // @ts-ignore
      .of(productSchema),
  })
  .test("check-at-least-one", (selections, ctx) => {
    const { products } =
      selections as unknown as SetupPurchaserRequestFormValues;
    const allProducts = [...products];
    const result =
      allProducts.length > 0 &&
      allProducts.some(
        (p) => isValidNumber(p.unitPrice) && isValidNumber(p.paidUnits),
      );
    //Workaround for yup BUG: https://github.com/jaredpalmer/formik/issues/2146
    return (
      result ||
      ctx.createError({
        message: "At least one product must be selected",
        path: "root",
      })
    );
  });
